// extracted by mini-css-extract-plugin
export default {"input-group":"filter_input-group__gJYCX","input-group_label":"filter_input-group_label__L29XT","form":"filter_form__wsCh2"};